import styled from 'styled-components';
import { rem } from 'polished';
import { applyStyleModifiers } from 'styled-components-modifiers';

const MODIFIER_CONFIG = {
  error: ({ theme }) => `
    color: ${theme.palette.primary[1]};
  `,

  success: ({ theme }) => `
    color: ${theme.palette.primary[2]};
  `,

  warning: ({ theme }) => `
    color: ${theme.palette.primary[3]};
  `,
};

const StatusText = styled.div`
  font-family: SF Pro Display, sans-serif;
  font-size: ${rem('14px')};
  color: ${(props) => props.theme.palette.label};
  flex-basis: 100%;
  padding-top: 0.25rem;

  ${applyStyleModifiers(MODIFIER_CONFIG)};
`;

export default StatusText;
